import { Placeholder } from '@sitecore-jss/sitecore-jss-nextjs';
import useHelpers from 'hooks/helpers';
import { useMemo } from 'react';
import HighlightItem from 'components/Tiles/HighlightItem';

const HighlightSection = ({ rendering, fields }) => {
  const { anchorId, backgroundClass } = useHelpers(rendering);
  const numberOfItems: number = fields?.items?.length;
  const showComponent = numberOfItems >= 1 && numberOfItems < 7;
  const oneOrThreeItems = numberOfItems === 1 || numberOfItems === 3;
  const mobileItemColClass = oneOrThreeItems ? 'col-12' : 'col-6';

  const highlightItemColClass = useMemo(() => {
    switch (numberOfItems) {
      case 2:
        return 'col-md-6';
      case 4:
        return 'col-md-3';
      default:
        return 'col-md-4';
    }
  }, [numberOfItems]);

  if (!showComponent) return null;

  return (
    <section
      id={anchorId}
      data-e2e-component-uid={rendering.uid}
      className="default-section-padding background-white"
    >
      <div className="container">
        <Placeholder name="abrdn-tiles-heading" rendering={rendering} className="mb-4" />
      </div>
      <div className={backgroundClass}>
        <div className="container">
          <div className="row" data-testid="items">
            {fields.items.map((item: any) => (
              <div
                key={item.id}
                className={`my-2 ${mobileItemColClass} ${highlightItemColClass}`}
                data-testid={item.id}
              >
                <HighlightItem
                  fields={item.fields}
                  numberOfItems={numberOfItems}
                  data-testid={item.displayName}
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default HighlightSection;
